/* section-garnberater.js - yarn-advisor quiz
 *
 * Logic ported verbatim from the old (live) bonifaktur theme so users get
 * the same recommendations across both themes during the migration. The
 * scoring weights, AJAX stock check, curated-boost map, compromise hints
 * and Knittipedia article surfacing all match the source-of-truth at
 * old-theme/sections/garnberater.liquid (lines 783-1391).
 *
 * Data (92 products + article mapping) lives in assets/garnberater-data.json
 * so the section file stays readable and edits to the catalogue don't churn
 * the section markup.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-garnberater]');
  if (!root) return;

  var DATA_URL = root.dataset.dataUrl;
  if (!DATA_URL) return;

  var currentStep = 0;
  var answers = {};
  var totalSteps = 5;
  var DATA = null;

  fetch(DATA_URL, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      DATA = data || { products: [], articles: {}, curated_boost: {} };
      buildProgress();
      bindOptions();
      bindNextButtons();
      bindBackButtons();
      bindRestart();
      updateProgress();
    });

  function buildProgress() {
    var bar = root.querySelector('[data-gb-progress]');
    if (!bar) return;
    bar.innerHTML = '';
    for (var i = 0; i < totalSteps; i++) {
      var dot = document.createElement('span');
      dot.className = 'gb-dot';
      dot.dataset.step = String(i);
      bar.appendChild(dot);
    }
  }

  function bindOptions() {
    root.querySelectorAll('[data-gb-option]').forEach(function (btn) {
      btn.addEventListener('click', handleOptionClick);
    });
  }

  function handleOptionClick(e) {
    var btn = e.currentTarget;
    var optionsDiv = btn.parentElement;
    var question = optionsDiv.dataset.gbQuestion;
    optionsDiv.querySelectorAll('[data-gb-option]').forEach(function (s) { s.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    answers[question] = btn.dataset.gbValue;
    var screen = btn.closest('[data-gb-step]');
    var nextBtn = screen.querySelector('[data-gb-next]');
    if (nextBtn) nextBtn.classList.add('is-enabled');
  }

  function bindNextButtons() {
    root.querySelectorAll('[data-gb-next]').forEach(function (btn) {
      btn.addEventListener('click', handleNextClick);
    });
  }

  function handleNextClick(e) {
    var btn = e.currentTarget;
    if (!btn.classList.contains('is-enabled')) return;
    var step = parseInt(btn.dataset.step, 10);
    if (step < totalSteps - 1) { currentStep = step + 1; showStep(currentStep); }
    else { showResults(); }
  }

  function bindBackButtons() {
    root.querySelectorAll('[data-gb-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (currentStep > 0) { currentStep--; showStep(currentStep); }
      });
    });
  }

  function bindRestart() {
    var rs = root.querySelector('[data-gb-restart]');
    if (rs) rs.addEventListener('click', restart);
  }

  function showStep(step) {
    root.querySelectorAll('[data-gb-step]').forEach(function (s) { s.classList.remove('is-active'); });
    var target = root.querySelector('[data-gb-step="' + step + '"]');
    if (target) target.classList.add('is-active');
    var results = root.querySelector('[data-gb-results]');
    if (results) results.classList.remove('is-active');
    updateProgress();
  }

  function updateProgress() {
    root.querySelectorAll('.gb-dot').forEach(function (d) {
      var s = parseInt(d.dataset.step, 10);
      d.classList.remove('is-active', 'is-done');
      if (s === currentStep) d.classList.add('is-active');
      if (s < currentStep) d.classList.add('is-done');
    });
  }

  function restart() {
    currentStep = 0;
    answers = {};
    root.querySelectorAll('[data-gb-option]').forEach(function (b) { b.classList.remove('is-selected'); });
    root.querySelectorAll('[data-gb-next]').forEach(function (b) { b.classList.remove('is-enabled'); });
    var results = root.querySelector('[data-gb-results]');
    if (results) results.classList.remove('is-active');
    showStep(0);
  }

  function showResults() {
    root.querySelectorAll('[data-gb-step]').forEach(function (s) { s.classList.remove('is-active'); });
    root.querySelectorAll('.gb-dot').forEach(function (d) { d.classList.add('is-done'); });
    var resultsEl = root.querySelector('[data-gb-results]');
    if (resultsEl) resultsEl.classList.add('is-active');

    var products = DATA.products || [];
    var curatedBoost = DATA.curated_boost || {};
    var scored = [];

    for (var p = 0; p < products.length; p++) {
      var yarn = products[p];
      var score = 0;
      var reasons = [];
      var useCases = yarn.use_cases || [];
      var hasMat = function (m) { return yarn.materials.indexOf(m) >= 0; };
      var hasTag = function (t) { return yarn.tags.indexOf(t) >= 0; };
      var isSmallSkein = yarn.unit_g && yarn.unit_g < 30;

      var project = answers.project;
      if (project === 'socken') {
        if (hasTag('Sockengarn')) { score += 40; reasons.push(bfT('gb_t_sock', 'Sockengarn')); }
        else if ((yarn.weight_class === 'Fingering' || yarn.weight_class === 'Light Fingering') && hasTag('Nylon')) { score += 15; }
        else if (yarn.weight_class === 'Fingering' || yarn.weight_class === 'Light Fingering') { score -= 10; }
        else { score -= 25; }
        if (useCases.indexOf('Socken') >= 0) score += 15;
        if (isSmallSkein) score -= 30;
      } else if (project === 'pullover') {
        if (['DK','Worsted','Aran','Sport'].indexOf(yarn.weight_class) >= 0) { score += 30; reasons.push(yarn.weight_class); }
        else if (yarn.weight_class === 'Fingering') { score += 8; }
        else { score -= 5; }
        if (useCases.indexOf('Pullover') >= 0) { score += 15; reasons.push(bfT('gb_t_for_sweaters', 'Für Pullover')); }
        if (isSmallSkein) score -= 30;
      } else if (project === 'tuch') {
        if (['Lace','Light Fingering','Fingering'].indexOf(yarn.weight_class) >= 0) { score += 30; reasons.push(yarn.weight_class); }
        else { score -= 5; }
        if (useCases.indexOf('Tuch') >= 0) { score += 15; reasons.push(bfT('gb_t_for_shawls', 'Für Tücher')); }
        if (isSmallSkein) score -= 20;
      } else if (project === 'accessoires') {
        if (['DK','Worsted','Aran','Bulky','Sport'].indexOf(yarn.weight_class) >= 0) { score += 20; reasons.push(yarn.weight_class); }
        else { score += 3; }
        if (useCases.indexOf('Accessoires') >= 0) score += 10;
        if (isSmallSkein) score -= 20;
      } else if (project === 'baby') {
        if (useCases.indexOf('Baby') >= 0) { score += 30; reasons.push(bfT('gb_t_baby', 'Baby-geeignet')); }
        else { score += 3; }
        if (yarn.certifications.length > 0) { score += 18; reasons.push(bfT('gb_t_certified', 'Zertifiziert')); }
        if (yarn.superwash === true) { score += 12; reasons.push(bfT('gb_t_machine_wash', 'Maschinenwaschbar')); }
        if (yarn.mulesing_free) score += 5;
        if (yarn.bio) { score += 12; reasons.push(bfT('gb_t_organic', 'Bio')); }
        if (isSmallSkein) score -= 30;
      } else {
        score += 8;
      }

      var priority = answers.priority;
      if (priority === 'weichheit') {
        if (hasMat('Merino')) { score += 18; reasons.push(bfT('gb_t_merino', 'Merino')); }
        if (hasMat('Alpaka') || hasMat('Baby Suri Alpaka')) { score += 18; reasons.push(bfT('gb_t_alpaca', 'Alpaka')); }
        if (hasMat('Kaschmir')) { score += 18; reasons.push(bfT('gb_t_cashmere', 'Kaschmir')); }
        if (hasMat('Seide')) score += 10;
        if (hasMat('Acryl') && !hasMat('Merino') && !hasMat('Alpaka')) score -= 8;
      } else if (priority === 'haltbarkeit') {
        if (yarn.superwash === true) { score += 15; reasons.push(bfT('gb_t_superwash', 'Superwash')); }
        if (hasTag('Nylon')) { score += 12; reasons.push(bfT('gb_t_nylon', 'Nylon-Anteil')); }
        if (hasMat('Seide') && !hasTag('Nylon')) score -= 5;
      } else if (priority === 'nachhaltigkeit') {
        if (yarn.bio) { score += 22; reasons.push(bfT('gb_t_organic', 'Bio')); }
        if (yarn.mulesing_free) { score += 15; reasons.push(bfT('gb_t_mulesing_free', 'Mulesing-frei')); }
        if (yarn.certifications.length > 0) { score += 15; reasons.push(yarn.certifications.join(', ')); }
      } else if (priority === 'farben') {
        var colPts = 0;
        if (yarn.colors && yarn.colors > 0) {
          colPts = Math.min(28, Math.round(Math.sqrt(yarn.colors) * 3));
          if (colPts >= 8) reasons.push(bfT('gb_reason_colors', '{count} Farben').replace('{count}', yarn.colors));
        }
        if (yarn.colors && yarn.colors <= 3) colPts = -3;
        score += colPts;
        if (yarn.hand_dyed) { score += 15; reasons.push(bfT('hand_dyed', 'Handgefärbt')); }
      }

      var material = answers.material;
      if (material === 'merino') {
        if (hasMat('Merino')) { score += 25; reasons.push(bfT('gb_t_merino', 'Merino')); }
        else if (hasMat('Schurwolle')) score -= 3;
        else score -= 8;
      } else if (material === 'pflanzlich') {
        var hasPlant = hasMat('Baumwolle') || hasMat('Leinen');
        if (hasMat('Baumwolle')) { score += 25; reasons.push(bfT('gb_t_cotton', 'Baumwolle')); }
        if (hasMat('Leinen')) { score += 25; reasons.push(bfT('gb_t_linen', 'Leinen')); }
        if (!hasPlant) score -= 12;
      } else if (material === 'luxus') {
        var hasLux = false;
        if (hasMat('Alpaka') || hasMat('Baby Suri Alpaka')) { score += 20; reasons.push('Alpaka'); hasLux = true; }
        if (hasMat('Seide')) { score += 20; reasons.push('Seide'); hasLux = true; }
        if (hasMat('Mohair')) { score += 15; reasons.push('Mohair'); hasLux = true; }
        if (hasMat('Kaschmir')) { score += 20; reasons.push('Kaschmir'); hasLux = true; }
        if (hasMat('Yak')) { score += 15; reasons.push('Yak'); hasLux = true; }
        if (!hasLux) score -= 8;
      }

      var washable = answers.washable;
      if (washable === 'ja') {
        if (yarn.superwash === true) score += 18;
        else if (yarn.superwash === false) score -= 20;
        else score -= 8;
      } else if (washable === 'nein') {
        if (yarn.superwash === false) score += 5;
        if (yarn.superwash === null) score += 2;
      }

      var budget = answers.budget;
      var effPrice = yarn.price;
      if (isSmallSkein && yarn.price !== null && yarn.unit_g > 0) {
        effPrice = Math.round(yarn.price / yarn.unit_g * 50 * 100) / 100;
      }
      if (budget === 'unter10' && effPrice !== null) {
        if (effPrice <= 10) { score += 20; reasons.push(bfT('gb_t_budget', 'Budget-freundlich')); }
        else if (effPrice <= 15) score -= 10;
        else if (effPrice <= 25) score -= 25;
        else score -= 35;
      } else if (budget === '10-20' && effPrice !== null) {
        if (effPrice >= 10 && effPrice <= 20) score += 18;
        else if (effPrice < 10) score += 8;
        else if (effPrice <= 30) score -= 10;
        else score -= 20;
      } else if (budget === 'ueber20' && effPrice !== null) {
        if (effPrice > 20) score += 15;
        else if (effPrice > 15) score += 5;
      }

      if (Object.prototype.hasOwnProperty.call(curatedBoost, yarn.handle)) {
        score += curatedBoost[yarn.handle];
        reasons.push(bfT('gb_recommendation', 'Empfehlung'));
      }
      if (priority !== 'farben' && yarn.colors && yarn.colors > 50) score += 3;

      var rav = yarn.ravelry_projects || 0;
      if (rav > 5000)  score += 2;
      if (rav > 15000) score += 2;
      if (rav > 30000) { score += 2; reasons.push(bfT('gb_t_popular', 'Beliebt')); }
      if (rav > 50000) score += 2;

      var uniqueReasons = [];
      var seen = {};
      for (var r = 0; r < reasons.length; r++) {
        if (!seen[reasons[r]]) { uniqueReasons.push(reasons[r]); seen[reasons[r]] = true; }
      }

      scored.push({ yarn: yarn, score: score, reasons: uniqueReasons });
    }

    scored.sort(function (a, b) { return b.score - a.score; });
    var candidates = scored.filter(function (s) { return s.score > 0; }).slice(0, 10);

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var projectAns = answers.project;
    var promises = candidates.map(function (item) {
      return fetch(rootUrl + 'products/' + item.yarn.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.available) {
            item.score -= 50;
            item.stockStatus = 'out';
            item.availableColors = 0;
            item.totalColors = data.variants ? data.variants.length : 0;
          } else {
            var availableCount = 0;
            var totalVariants = data.variants ? data.variants.length : 1;
            if (data.variants) {
              for (var v = 0; v < data.variants.length; v++) if (data.variants[v].available) availableCount++;
            }
            item.availableColors = availableCount;
            item.totalColors = totalVariants;
            var ratio = totalVariants > 0 ? availableCount / totalVariants : 1;
            if (totalVariants > 3 && ratio < 0.15) { item.score -= 15; item.stockStatus = 'very-low'; }
            else if (totalVariants > 5 && ratio < 0.30) {
              item.score -= (projectAns === 'socken') ? 5 : 10;
              item.stockStatus = 'low';
            } else { item.stockStatus = 'ok'; }
          }
          var mainImg = '';
          if (data.media && data.media.length > 0 && data.media[0].src) mainImg = data.media[0].src;
          else if (data.images && data.images.length > 0) mainImg = data.images[0];
          else if (data.featured_image) mainImg = data.featured_image;
          if (mainImg) mainImg += (mainImg.indexOf('?') >= 0 ? '&' : '?') + 'width=200';
          item.mainImage = mainImg;
          var previews = [];
          var seenUrls = {};
          if (data.images && data.images.length > 1) {
            for (var img = 1; img < data.images.length && previews.length < 5; img++) {
              var imgUrl = data.images[img];
              if (imgUrl && !seenUrls[imgUrl]) {
                seenUrls[imgUrl] = true;
                imgUrl += (imgUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=80';
                previews.push(imgUrl);
              }
            }
          }
          item.colorPreviews = previews;
          return item;
        })
        .catch(function () {
          item.stockStatus = 'unknown';
          item.availableColors = 0;
          item.totalColors = 0;
          item.mainImage = '';
          item.colorPreviews = [];
          return item;
        });
    });

    Promise.all(promises).then(function (checked) {
      checked.sort(function (a, b) { return b.score - a.score; });
      var top = checked.filter(function (s) { return s.score > 0; }).slice(0, 5);
      var maxScore = top.length > 0 ? top[0].score : 1;
      renderResults(top, maxScore);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function renderResults(top, maxScore) {
    var html = '';
    var fallbackSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M7 8c2 2.5 7 3 10 .5"/><path d="M5.5 13c2.5-2 5.5-2 7-1s4.5.5 6.5-1"/><path d="M7 17.5c2.5-1.5 6-1.5 10 0"/></svg>';

    for (var i = 0; i < top.length; i++) {
      var item = top[i];
      var y = item.yarn;
      var pct = Math.round((item.score / maxScore) * 100);
      var unitLabel = y.unit_g ? '/ ' + y.unit_g + ' g' : '';
      var priceStr = y.price ? y.price.toFixed(2).replace('.', ',') + ' €' : '';
      var displayName = y.name.replace(y.brand + ' ', '');
      var swatchContent = item.mainImage
        ? '<img src="' + esc(item.mainImage) + '" alt="' + esc(displayName) + '" loading="lazy">'
        : fallbackSvg;

      var displayReasons = item.reasons.filter(function (r) { return r !== 'Ausverkauft' && r !== 'Wenige verfügbar'; });
      var tagsHtml = '';
      for (var t = 0; t < Math.min(displayReasons.length, 3); t++) {
        tagsHtml += '<span class="gb-tag gb-tag--match t-mono">' + esc(displayReasons[t]) + '</span>';
      }
      var extras = [y.weight_class];
      if (y.hand_dyed) extras.push(bfT('hand_dyed', 'Handgefärbt'));
      for (var e = 0; e < extras.length; e++) {
        if (extras[e] && displayReasons.indexOf(extras[e]) < 0) {
          tagsHtml += '<span class="gb-tag t-mono">' + esc(extras[e]) + '</span>';
        }
      }

      var stockBadge = '';
      if (item.stockStatus === 'out') stockBadge = '<span class="gb-stock gb-stock--out t-mono">' + bfT('sold_out', 'Ausverkauft') + '</span>';
      else if (item.stockStatus === 'very-low') stockBadge = '<span class="gb-stock gb-stock--low t-mono">' + bfT('gb_few_colors', 'Nur wenige Farben') + '</span>';

      var colorwayHtml = '';
      if (item.availableColors > 0 && item.totalColors > 0) {
        colorwayHtml = '<div class="gb-colorway-info t-mono">' + bfT('gb_colors_available', '{avail} von {total} Farben verfügbar').replace('{avail}', item.availableColors).replace('{total}', item.totalColors) + '</div>';
      }
      var previewHtml = '';
      if (item.colorPreviews && item.colorPreviews.length > 0) {
        previewHtml = '<div class="gb-colorway-previews">';
        for (var cp = 0; cp < item.colorPreviews.length; cp++) {
          previewHtml += '<img class="gb-colorway-thumb" src="' + esc(item.colorPreviews[cp]) + '" alt="" loading="lazy">';
        }
        if (item.availableColors > item.colorPreviews.length + 1) {
          previewHtml += '<span class="gb-colorway-more t-mono">+' + (item.availableColors - item.colorPreviews.length) + '</span>';
        }
        previewHtml += '</div>';
      }

      html +=
        '<article class="gb-card">' +
          '<div class="gb-card__swatch">' + swatchContent + '</div>' +
          '<div class="gb-card__body">' +
            '<div class="gb-match t-mono"><span class="gb-match__pct">' + pct + '% Match</span>' + stockBadge + '</div>' +
            '<p class="gb-card__brand t-mono">' + esc(y.brand) + '</p>' +
            '<h3 class="gb-card__title">' + esc(displayName) + '</h3>' +
            '<p class="gb-card__detail">' + esc(y.material_detail) + '</p>' +
            '<ul class="gb-card__specs t-mono">' +
              (y.yardage_100g ? '<li>' + y.yardage_100g + ' m / 100 g</li>' : '') +
              (y.needle_size ? '<li>' + bfT('needle', 'Nadel') + ' ' + esc(y.needle_size) + ' mm</li>' : '') +
              (y.unit_g ? '<li>' + bfT('gb_g_per_ball', '{g} g / Knäuel').replace('{g}', y.unit_g) + '</li>' : '') +
            '</ul>' +
            colorwayHtml +
            previewHtml +
            '<div class="gb-card__tags">' + tagsHtml + '</div>' +
            '<div class="gb-card__foot">' +
              '<span class="gb-card__price">' + esc(priceStr) + '<span class="gb-card__price-unit t-mono"> ' + esc(unitLabel) + '</span></span>' +
              '<a class="gb-card__link t-mono" href="/products/' + esc(y.handle) + '">' + bfT('gb_view_in_shop', 'Im Shop ansehen') + ' →</a>' +
            '</div>' +
          '</div>' +
        '</article>';
    }
    var grid = root.querySelector('[data-gb-products]');
    if (grid) grid.innerHTML = html;

    var articles = [];
    var ART = DATA.articles || {};
    if (answers.project && answers.project !== 'egal' && ART[answers.project]) articles = articles.concat(ART[answers.project]);
    if (answers.priority === 'nachhaltigkeit' && ART.nachhaltigkeit) articles = articles.concat(ART.nachhaltigkeit);
    if (answers.material === 'pflanzlich' && ART.pflanzlich) articles = articles.concat(ART.pflanzlich);
    if (answers.material === 'luxus' && ART.luxus) articles = articles.concat(ART.luxus);
    if (answers.washable === 'ja' && ART.superwash) articles = articles.concat(ART.superwash);
    if (ART.pflege) articles = articles.concat(ART.pflege);
    var seen = {}; var uniq = [];
    for (var a = 0; a < articles.length; a++) {
      if (!seen[articles[a].handle]) { uniq.push(articles[a]); seen[articles[a].handle] = true; }
    }
    articles = uniq.slice(0, 3);
    if (articles.length === 0 && ART.general) articles = ART.general.slice(0, 2);

    var cHtml = '';
    for (var c = 0; c < articles.length; c++) {
      var art = articles[c];
      cHtml +=
        '<a class="gb-article" href="/blogs/knittipedia/' + esc(art.handle) + '">' +
          '<span class="gb-article__type t-mono">' + esc(art.type) + '</span>' +
          '<span class="gb-article__title">' + esc(art.title) + '</span>' +
          '<span class="gb-article__arr" aria-hidden="true">→</span>' +
        '</a>';
    }
    var artGrid = root.querySelector('[data-gb-articles]');
    if (artGrid) artGrid.innerHTML = cHtml;

    var sub = root.querySelector('[data-gb-subtitle]');
    if (sub) sub.textContent = top.length === 1
      ? bfT('gb_result_one', 'Wir haben ein Garn gefunden, das zu deinen Wünschen passt.')
      : bfT('gb_result_other', 'Wir haben {count} Garne gefunden, die zu deinen Wünschen passen.').replace('{count}', top.length);

    var hints = [];
    if (answers.material && answers.material !== 'egal' && top.length > 0) {
      var matLabels = { merino: 'Merino', pflanzlich: bfT('mat_plant', 'Baumwolle oder Leinen'), luxus: bfT('mat_luxury', 'Luxusfasern') };
      var matKey = answers.material;
      var matMatches = 0;
      for (var h = 0; h < Math.min(top.length, 3); h++) {
        var mats = top[h].yarn.materials;
        if (matKey === 'merino' && mats.indexOf('Merino') >= 0) matMatches++;
        else if (matKey === 'pflanzlich' && (mats.indexOf('Baumwolle') >= 0 || mats.indexOf('Leinen') >= 0)) matMatches++;
        else if (matKey === 'luxus' && (mats.indexOf('Alpaka') >= 0 || mats.indexOf('Baby Suri Alpaka') >= 0 || mats.indexOf('Seide') >= 0 || mats.indexOf('Mohair') >= 0 || mats.indexOf('Kaschmir') >= 0 || mats.indexOf('Yak') >= 0)) matMatches++;
      }
      if (matMatches === 0) {
        hints.push(bfT('gb_hint_material', 'Für <strong>{label}</strong> haben wir in Kombination mit deinen anderen Wünschen leider keine perfekte Übereinstimmung gefunden - die Ergebnisse sind die besten Kompromisse.').replace('{label}', (matLabels[matKey] || matKey)));
      }
    }
    if (answers.washable === 'ja' && top.length > 0) {
      var swMatches = 0;
      for (var h2 = 0; h2 < Math.min(top.length, 3); h2++) {
        if (top[h2].yarn.superwash === true) swMatches++;
      }
      if (swMatches === 0) {
        hints.push(bfT('gb_hint_handwash', 'Die meisten Garne in dieser Kombination sind <strong>nicht maschinenwaschbar</strong> - vielleicht ist Handwäsche doch eine Option?'));
      }
    }
    if (answers.budget && answers.budget !== 'egal' && top.length > 0) {
      var budgetLabels = { unter10: 'unter 10 €', '10-20': '10-20 €', ueber20: 'über 20 €' };
      var budgetMatches = 0;
      for (var h3 = 0; h3 < Math.min(top.length, 3); h3++) {
        var pr = top[h3].yarn.price;
        if (answers.budget === 'unter10' && pr <= 10) budgetMatches++;
        else if (answers.budget === '10-20' && pr >= 10 && pr <= 20) budgetMatches++;
        else if (answers.budget === 'ueber20' && pr > 20) budgetMatches++;
      }
      if (budgetMatches === 0) {
        hints.push(bfT('gb_hint_budget', 'In der Preisklasse <strong>{label}</strong> gibt es für deine Kombination wenig Auswahl - wir zeigen dir die besten Alternativen.').replace('{label}', budgetLabels[answers.budget]));
      }
    }
    var hintEl = root.querySelector('[data-gb-hint]');
    if (hintEl) {
      if (hints.length > 0) { hintEl.innerHTML = hints.join('<br>'); hintEl.hidden = false; }
      else { hintEl.hidden = true; }
    }
  }
})();
